
import create from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import createPoliciesSlice from "./slices/createPoliciesSlice";
import createAccountManagementSlice from "./slices/createAccountManagementSlice";
import createAppSlice from "./slices/createAppSlice";
import createBranchDeployerSlice from "./slices/createBranchDeployerSlice";
import createCollectionsSlice from "./slices/createCollectionsSlice";
import createKnowledgeValidationsSlice from "./slices/createKnowledgeValidationsSlice";
import createExploreAutoSaveSlice from "./slices/createExploreAutoSaveSlice";
import createExploreLeaveGuardSlice from "./slices/createExploreLeaveGuardSlice";
import createConversationsSlice from "./slices/createConversationsSlice";
import createPreviewSlice from "./slices/createPreviewSlice";
import createTripletsSlice from "./slices/createTripletsSlice";
import createCampaignSlice from "./slices/createCampaignSlice";
import createNotificationsSlice from "./slices/createNotificationsSlice";
import createSpeechPlayerSlice from "./slices/createSpeechPlayerSlice";
import createConfigEditorSlice from "./slices/createConfigEditorSlice";

// Local dev server only. In deployed builds (including previews/staging) the
// devtools middleware makes the Redux DevTools extension serialize the entire
// store on every action - with large collection configs that is hundreds of MB
// per state update and crashes the tab (OOM) when switching between tables.
const devtoolsEnabled = import.meta.env.DEV;
const useAppStore = create(
  devtools(
    subscribeWithSelector((...args) => ({
      ...createAppSlice(...args),
      ...createPreviewSlice(...args),
      ...createTripletsSlice(...args),
      ...createConversationsSlice(...args),
      ...createCollectionsSlice(...args),
      ...createKnowledgeValidationsSlice(...args),
      ...createExploreAutoSaveSlice(...args),
      ...createExploreLeaveGuardSlice(...args),
      ...createAccountManagementSlice(...args),
      ...createBranchDeployerSlice(...args),
      ...createCampaignSlice(...args),
      ...createNotificationsSlice(...args),
      ...createPoliciesSlice(...args),
      ...createSpeechPlayerSlice(...args),
      ...createConfigEditorSlice(...args)
    })),
    { name: "appStore", enabled: devtoolsEnabled }
  )
);
export default useAppStore;
